module.exports = __webpack_public_path__ + "img/back-icon.ad5aadf.svg";